export default () => `
  query($ids: [Int]) {
    variants(ids: $ids) {
      id
      sku
      color
      groupName
      imageUrl
      price
      productPath
      productType
      size
      stock
    }
  }
`
